export default {
    'en-us': {
        otaManagement: 'OTA Management',
        backgroundManagement: 'Background Management',
        alotManagement: 'AIoT Management',
        deviceManagement: 'Camera Management',
        deviceManagementPass: 'Device Management',
        itsManagement: 'ITS Management',
        itsManagementDetail: 'ITS Management Detail',
        userManagement: 'Setting',
        main: 'Home',
        dashboard: 'Dashboard',
        monitoring: 'Control Center',
        alert: 'Alert Center',
        control: 'Monitor Device',
        passDevice: 'Entrance Pass Device',
        account: 'Account',
        roles: 'Role',
        logs: 'Log Management',
        bulkImport: 'Batch-import',
        monitor: 'Security Monitoring',
        monitorManagement: 'Task Monitor',
        monitorPortrait: 'Portrait Management',
        portrait: 'Portrait Library',
        organization: 'Department',
        record: 'Monitoring Records',
        createDevice: 'Create Device',
        editDevice: 'Edit Device',
        task: 'Task Monitor',
        recordCenter: 'Record Center',
        PersonalCenter: 'personal center',
        createfaceControl: 'Create Watchlist Monitoring',
        createcrowdControl: 'Create Crowd Control',
        createcrowdStatistics: 'Create Crowd Statistics',
        editfaceControl: 'Edit Watchlist Monitoring',
        editcrowdControl: 'Edit Crowd Control',
        editcrowdStatistics: 'Edit Crowd Statistics',
        queueManagement: 'Queue Management',
        regionManagement: 'Zone Management',
        virtualArea: 'Virtual Zone',
        historyTotal: 'History Statistics',
        taskManagement: 'Task Monitor',
        queueDashboard: 'RealTime Dashboard',
        otaUpload: 'Update package',
        ota: 'IOT device',
        otaList: 'OTA Management',
        otaupload: 'OTA Upload',
        deviceList: 'Device List',
        deviceDetail: 'Device Detail',
        passSchedule: 'Pass Schedule',
        pass: 'Pass',
        passManagement: 'Pass Management',
        comparisonRecord: 'Comparison Record',
        alarmRecord: 'Alarm Record',
        staffManagement: 'Staff Management',
        whiteManagement: 'Allow List',
        visitorManagement: 'Visitor List',
        blackManagement: 'Blocked List',
        passTask: 'Pass Task',
        createQueueControl: 'create Queue Task',
        params: 'Parameter Settings',
        mapManagement: 'Map Management',
        basemapManagement: 'Basemap',
        renderKanban: 'Zone Overview',
        spaceManagement: 'Zone List',
        dataKanban: 'Detail Statistics',
        partitionDisplay: 'Sub-Zone Statistics',
        totalParkDisplay: 'Overall Statistics',
        shopsDisplay: 'Merchants Statistics',
        shopDisplay: 'Merchants Statistics',
        tools: 'Tools',
        faceOneToOne: 'Face Comparison(1:1)',
        faceOneToN: 'Face Comparison(1:N)',
        intelligentSearch: 'Search',
        trajectoryTracking: 'Trajectory Tracking',
        faceSearch: 'Portrait Retrieval',
        taskList: 'Monitor List',
        monitoringCenter: 'Monitor Center',
        snapRecord: 'Snap Record',
        panel: 'Dashboard',
        displayPanel: 'Insights Overview',
        visitorsPersona: 'Visitors Persona',
        trafficAnalysis: 'Flow Analysis',
        portraitManagement: 'Portrait Management',
        application: 'Application',
        populationStatisticsSask: 'Population Statistics Sask',
        queueTaskManagement: 'Queue Task Management',
        alarmCenter: 'Alert Center',
        createStaffDutyLeaveTask: 'Create Crowd Counting Task',
        createQueue: 'Create Queue Task',
        library: 'Portrait Management',
        portalSettings: 'Portal Settings',
        roleUserManagement: 'Role & User Management',
        Search: 'Search',
        Result: 'Result',
        portraitCenter: 'Portrait Center',
        dataMining: 'Data Mining',
        companions: 'Companions Analysis',
        resultDetails: 'Result Details',
        fileCluster: 'File Cluster',
        bigData: 'Frequency Analysis',
        createRealtimeCluster: 'Create File Cluster Task',
        editRealtimeCluster: 'Edit File Cluster Task',
        realtimeCluster: 'File Cluster Task',
        libraryManagement: 'Library',
        fold: 'Fold',
        relationChart: 'Relation Chart',
        attendanceMag: 'Attendance Management',
    },
    zh: {
        otaManagement: 'OTA管理',
        backgroundManagement: '背景图管理',
        alotManagement: 'AIoT管理',
        deviceManagement: '相机管理',
        deviceManagementPass: '设备管理',
        itsManagement: '大华相机',
        itsManagementDetail: '设备详情',
        userManagement: '系统管理',
        main: '首页',
        dashboard: '仪表盘',
        monitoring: '监控中心',
        snapRecord: '快照',
        alert: '告警中心',
        control: '设备管理',
        passDevice: '通行设备管理',
        account: '用户管理',
        roles: '角色及权限管理',
        logs: '日志管理',
        bulkImport: '批量导入',
        monitor: '布控',
        monitorManagement: '解析布控',
        monitorPortrait: '库管理',
        portrait: '库管理（身份库）',
        organization: '部门管理',
        record: '布控记录',
        createDevice: '添加设备',
        editDevice: '修改设备',
        task: '任务管理',
        recordCenter: '记录中心',
        PersonalCenter: '个人中心',
        createfaceControl: '创建人脸布控',
        createcrowdControl: '创建人群布控',
        createcrowdStatistics: '创建人数统计',
        editfaceControl: '修改人脸布控',
        editcrowdControl: '修改人群布控',
        editcrowdStatistics: '修改人数统计',
        regionManagement: '区域管理',
        virtualArea: '虚拟区域',
        queueManagement: '排队管理',
        historyTotal: '历史统计',
        taskManagement: '任务管理',
        createQueueControl: '创建排队任务',
        queueDashboard: '实时看板',
        otaUpload: '更新包管理',
        ota: 'IOT设备',
        otaList: 'OTA更新列表',
        otaupload: '更新包列表',
        deviceList: '设备列表',
        deviceDetail: '设备详情',
        passSchedule: '通行时刻表',
        pass: '通行',
        passManagement: '通行记录',
        comparisonRecord: '通行对比记录',
        alarmRecord: '告警记录',
        staffManagement: '库管理',
        whiteManagement: '库管理',
        visitorManagement: '访客管理',
        blackManagement: '黑名单管理',
        passTask: '通行任务',
        params: '参数管理',
        mapManagement: '地图管理',
        basemapManagement: '底图管理',
        renderKanban: '渲染看板',
        spaceManagement: '空间管理',
        dataKanban: '数据看板',
        partitionDisplay: '分区显示',
        totalParkDisplay: '总园区显示',
        shopsDisplay: '店铺显示',
        shopDisplay: '人脸检索',
        intelligentSearch: '搜索中心',
        monitoringCenter: '监控中心',
        tools: '工具',
        faceOneToOne: '人脸1:1',
        faceOneToN: '人脸1:N',
        trajectoryTracking: '轨迹追踪',
        faceSearch: '人脸搜索',
        taskList: '任务列表',
        panel: '展示看板',
        displayPanel: '展示看板',
        visitorsPersona: '客户分析',
        trafficAnalysis: '人流分析',
        portraitManagement: '库管理',
        application: '场景化应用',
        populationStatisticsSask: '人群统计任务',
        queueTaskManagement: '排队任务管理',
        alarmCenter: '告警中心',
        createStaffDutyLeaveTask: '创建离岗任务',
        createQueue: '创建排队任务',
        library: '库管理',
        portalSettings: '门户管理',
        roleUserManagement: '角色和用户管理',
        Search: '搜索中心',
        Result: '搜索结果',
        portraitCenter: '画像中心',
        dataMining: '数据挖掘',
        companions: '同行人分析',
        resultDetails: '结果详情',
        fileCluster: '人像聚档',
        bigData: '频率分析',
        createRealtimeCluster: '创建人像聚档任务',
        editRealtimeCluster: '编辑人像聚档任务',
        realtimeCluster: '人像聚档任务',
        libraryManagement: '库',
        fold: '折叠',
        relationChart: '脑图',
        attendanceMag: '考勤管理',
    },
};
